import type { CSSProperties } from 'react';

/**
 * An illustrative week of court usage. Nothing here is live data - the pattern
 * is fixed and the cells animate on a loop to show quiet hours filling up.
 */

type Tone = '.' | 'r' | 'p' | 'b';

const TONE: Record<Tone, string> = {
  '.': 'rgba(255,255,255,.05)',
  r: 'rgba(76,125,255,.65)',
  p: 'rgba(47,224,214,.7)',
  b: '#C8FF3C',
};

const PATTERN: Array<[string, string]> = [
  ['08:00', '..r...r'],
  ['10:00', '.r..r.b'],
  ['12:00', 'r..r..b'],
  ['14:00', '.r.r.bb'],
  ['16:00', 'rrprppb'],
  ['18:00', 'ppbbbbb'],
  ['20:00', 'pbbbppb'],
  ['22:00', '.rr.rp.'],
];

export default function WeekGrid() {
  return (
    <div className="week">
      {PATTERN.map(([hour, row], rowIndex) => (
        <div className="week-row" key={hour}>
          <span className="h">{hour}</span>
          {row.split('').map((char, colIndex) => (
            <span
              key={colIndex}
              className="cell"
              style={
                {
                  '--to': TONE[(char as Tone) in TONE ? (char as Tone) : '.'],
                  animationDelay: `${(rowIndex * 0.16 + colIndex * 0.09).toFixed(2)}s`,
                } as CSSProperties
              }
            />
          ))}
        </div>
      ))}
    </div>
  );
}
